import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  BoxTotal: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    alignSelf: 'stretch',
  },
  Box: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    flexShrink: 0,
  },
  BoxHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexShrink: 0,
    borderBottom: '1px solid var(--Gray-200, #EAECF0)',
    background: '#FFF',
    height: '72px',
    width: '100%',
    padding: '0 24px',
    position: 'sticky',
    top: 0,
  },
  BoxContent: {
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column',
    gap: '24px',
    flex: '1 0 0',
    padding: '16px',
    borderBottom: '1px solid var(--Gray-200, #EAECF0)',
    background: 'var(--Gray-50, #F9FAFB)',
    paddingBottom: '150px',
    width: '100%',
  },
  BoxFooter: {
    display: 'flex',
    padding: '16px',
    alignItems: 'flex-start',
    flexDirection: 'column',
    gap: '12px',
    boxShadow: '0px -4px 8px -2px rgba(16, 24, 40, 0.10), 0px -2px 4px -2px rgba(16, 24, 40, 0.06)',
    background: '#FFF',
    width: '100%',
    position: 'sticky',
    bottom: 0,
  },
  BoxTextFooter: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    alignSelf: 'stretch',
  },
  LeftHeaderBox: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
  },
  BoxStatus: {
    display: 'flex',
    alignItems: 'center',
    padding: '4px 12px',
    borderRadius: '16px',
  },
  BoxIcon: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  BoxOrderSummaryOuter: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    border: 'none',
    background: 'transparent',
    padding: 0,
    alignSelf: 'stretch',
  },
  BoxOrderSumary: {
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column',
    gap: '16px',
    padding: '16px 16px 0px 16px',
    alignSelf: 'stretch',
    borderRadius: '8px',
    border: '1px solid var(--Gray-200, #EAECF0)',
    background: '#FFF',
  },
  BoxContentOrderSumary: {
    alignItems: 'center',
    gap: '16px',
    paddingBottom: '24px',
    alignSelf: 'stretch',
  },
  ContentOrderSumary: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '16px',
    paddingBottom: '1 0 0',
  },
  CompactSummaryBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    padding: '20px',
    backgroundColor: 'var(--Base-White, #FFF)',
    borderRadius: '12px',
    border: '1px solid var(--Gray-200, #E4E7EC)',
    marginBottom: '24px',
    boxShadow: '0px 1px 3px rgba(16, 24, 40, 0.1), 0px 1px 2px rgba(16, 24, 40, 0.06)',
  },
  MultiOrderBadge: {
    padding: '6px 16px',
    backgroundColor: 'var(--Gray-100, #F2F4F7)',
    borderRadius: '24px',
    display: 'flex',
    alignItems: 'center',
  },
  TimePill: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    backgroundColor: 'var(--Gray-50, #F9FAFB)',
    padding: '6px 14px',
    borderRadius: '20px',
    border: '1px solid var(--Gray-200, #EAECF0)',
  },
  SeatBox: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginLeft: 'auto',
  },
  BoxContentPaymentSumary: {
    alignSelf: 'stretch',
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column',
  },
  BoxPaymentSumary: {
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column',
    gap: '16px',
    padding: '16px',
    alignSelf: 'stretch',
    borderRadius: '8px',
    border: '1px solid var(--Gray-200, #EAECF0)',
    background: '#FFF',
  },
  TextTitlePaymentDetail: {
    color: 'var(--Gray-700, #475467)',
    textOverflow: 'ellipsis',
    display: '-webkit - box',
    flex: '1 0 0',
  },
  TextTotalPayment: {
    color: 'var(--Gray-700, #1D2939)',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit - box',
    flex: '1 0 0',
  },
  PaymentMethod: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  BoxButton: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    width: '100%',
  },
  LoadingOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999,
  },
  BoxPriceFood: {
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column',
    gap: '4px',
  },
  BoxInformationFood: {
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column',
    gap: '8px',
    alignSelf: 'stretch',
    flex: '1 0 0',
  },
  StarFood: {
    color: 'var(--Gray-600, #475467)',
    overflow: 'hidden',
    display: '-webkit-box',
  },
  BoxStarFood: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    alignContent: 'start',
    alignSelf: 'stretch',
    flexWrap: 'wrap',
    gap: '8px',
  },
  BoxTopic: {
    display: 'flex',
    alignItems: 'center',
    alignContent: 'center',
  },
  SummaryRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  ItemsPriceGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
  },
  TimeSeatRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '8px',
  },
  PaymentDetailsBorder: {
    borderTop: '1px solid var(--Gray-300, #D0D5DD)',
    padding: '8px 0px',
    gap: '8px',
    justifyContent: 'center',
    alignSelf: 'stretch',
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column',
  },
  BoxInformationForEachPayment: {
    padding: '8px 0px',
    gap: '8px',
    justifyContent: 'center',
    alignSelf: 'stretch',
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column',
  },
  InformationForEachPayment: {
    padding: '8px 0px',
    gap: '8px',
    justifyContent: 'space-between',
    alignSelf: 'stretch',
    display: 'flex',
    alignItems: 'flex-start',
  },
  Line: {
    height: '50%',
    width: '1px',
    background: 'var(--Gray-200, #EAECF0)',
  },
  BoxDamaged: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  QuantityBox: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
  },
  QuantityButton: {
    minWidth: '40px',
    width: '40px',
    height: '40px',
    borderRadius: '8px',
    border: '1px solid #d1d5db',
  },
  QuantityIcon: {
    width: '100%',
    height: '100%',
  },
  BoxButtonBack: {
    display: 'flex',
    height: '62px',
    padding: '16px 28px',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '12px',
    flex: '1 0 0',
    borderRadius: '8px',
    border: '1px solid var(--Primary-50, #F2FBF3)',
    background: 'var(--Primary-50, #F2FBF3) !important',
    width: '100%',
  },
}));

const buttonStyle = {
  display: 'flex',
  padding: '16px 28px',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '12px',
  flex: '1 0 0',
  borderRadius: '8px',
  border: '1px solid var(--Primary-50, #F2FBF3)',
  background: 'var(--Primary-50, #F2FBF3) !important',
  width: '100%',
};

const buttonPrintStyle = {
  display: 'flex',
  padding: '8px 12px',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '8px',
  borderRadius: '8px',
  textTransform: 'none',
  border: '1px solid var(--Gray-300, #D0D5DD)',
  background: 'var(--Base-White, #FFF)',
  boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
  '&:hover': { backgroundColor: 'var(--Base-White, #FFF)' },
  '& > span': {
    margin: 0,
  },
};

const textButton = {
  color: 'var(--Primary-700, #296C32)',
  fontSize: '18px',
  fontWeight: '600',
  lineHeight: '28px',
};

const buttonBackStyle = {
  display: 'flex',
  padding: '8px 24px',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '8px',
  height: '62px',
  width: 'max-content',
  borderRadius: '8px',
  textTransform: 'none',
  border: '1px solid var(--Primary-50, #F2FBF3)',
  background: 'var(--Primary-50, #F2FBF3) !important',
  '&:hover': { backgroundColor: 'var(--Base-White, #FFF)' },
  '& > span': {
    margin: 0,
  },
};

export { useStyles, buttonStyle, textButton, buttonPrintStyle, buttonBackStyle };
